import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {IGETRequest, IRESTRequest} from '../models/rest.models';

@Injectable({
  providedIn: 'root'
})
export class RestService {

  constructor(private httpClient: HttpClient) { }

  private static buildURL<T>(request: IRESTRequest<T>): string {
    let baseURL = request.url;

    if (request.pathVariables) {
      request.pathVariables.forEach(path => baseURL = baseURL.concat('/' + path));
    }

    const url = new URL(baseURL);

    if (request.queryParameters) {
      Object.entries(request.queryParameters)
        .filter(([key, value]) => key && value)
        .forEach(([key, value]) => url.searchParams.append(key, value));
    }

    return url.toString();
  }

  public get<T>(request: IGETRequest): Observable<T> {
    return this.httpClient.get<T>(
      RestService.buildURL(request),
      {
        headers: request.headers
      }
    );
  }

  public getBlob(request: IGETRequest): Observable<Blob> {
    return this.httpClient.request('GET', RestService.buildURL(request), {
      headers: request.headers,
      responseType: 'blob'
    });
  }

  public post<R, T>(request: IRESTRequest<R>): Observable<T> {
    return this.httpClient.post<T>(
      RestService.buildURL(request),
      request.body,
      {
        headers: request.headers
      }
    );
  }

  public put<R, T>(request: IRESTRequest<R>): Observable<T> {
    return this.httpClient.put<T>(
      RestService.buildURL(request),
      request.body,
      {
        headers: request.headers
      }
    );
  }

  public delete<R, T>(request: IRESTRequest<R>): Observable<T> {
    return this.httpClient.delete<T>(
      RestService.buildURL(request),
      {
        headers: request.headers
      }
    );
  }

  public patch<R, T>(request: IRESTRequest<R>): Observable<T> {
    return this.httpClient.patch<T>(
      RestService.buildURL(request),
      request.body,
      {
        headers: request.headers
      }
    );
  }

  public getLog<T>(request: IGETRequest): Observable<T> {
    return this.httpClient.get<T>(
      request.url,
      {
        headers: request.headers,
        reportProgress: true,
        responseType: 'text' as 'json'
      }
    );
  }
}
